/**
 * `.result-box` — the mockup's titled panel every §F6 result is rendered into, plus the
 * two table helpers Part H's panels all need.
 *
 * `pad` is the mockup's `<div style="padding:…">` around a chart; a table goes in
 * unpadded, flush to the box's own border, which is what `.result-box table.mini` expects.
 *
 * `scroll` is not the mockup's: §H5's transition matrix is (classes + 1) columns wide and
 * the dock is 390 px, so at eight land-cover classes the table has to scroll inside its box
 * rather than push the dock's own layout sideways.
 */
import type { ReactNode } from 'react';

export interface ResultBoxProps {
  title: ReactNode;
  children: ReactNode;
  /** Inset the body — for charts and prose, not for a `table.mini`. */
  pad?: boolean;
  /** Let a too-wide body scroll horizontally inside the box (§H5's matrix). */
  scroll?: boolean;
  className?: string;
  id?: string;
}

export function ResultBox({ title, children, pad = false, scroll = false, className, id }: ResultBoxProps) {
  const body = pad ? <div className="result-pad">{children}</div> : children;
  return (
    <div className={`result-box${className ? ` ${className}` : ''}`} id={id}>
      <h5>{title}</h5>
      {scroll ? <div className="result-scroll">{body}</div> : body}
    </div>
  );
}

/** A footnote under a box — the mockup's `.tbl-note`. */
export function ResultNote({ children }: { children: ReactNode }) {
  return <div className="tbl-note">{children}</div>;
}

export default ResultBox;
